import React, { FC } from 'react'
import { ToggleSwitch, Checkbox, Handle, SwitchWrap } from './styles'

export interface SwitchProps {
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  label?: string
  name?: string
  value?: string
  checked?: boolean
}

const Switch: FC<SwitchProps> = ({ handleChange, checked, value, label, name }) => {
  const checkBlock = (
    <ToggleSwitch>
      <Checkbox name={name} value={value} checked={checked} onChange={handleChange} />
      <Handle />
    </ToggleSwitch>
  )

  return label ? (
    <SwitchWrap>
      <span>{label}</span> {checkBlock}
    </SwitchWrap>
  ) : (
    checkBlock
  )
}

export default Switch
